import { render, staticRenderFns } from "./DoctorGeneral.vue?vue&type=template&id=6943cc78&"
import script from "./DoctorGeneral.vue?vue&type=script&lang=js&"
export * from "./DoctorGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports